import { Fragment } from 'react'
import cx from 'classnames'
import styles from './ButtonGroup.module.scss'
import { Button } from '~elements'
import { ButtonGroupProps } from 'types'
import { getGtmLinkPosition } from '~analyticsUtils'

const ButtonGroup = ({
  analytics,
  buttons = [],
  buttonSizeOverride,
  headline = '',
  isFullWidthOverride,
  justifyOverride = 'left',
  layout
}: ButtonGroupProps) => {
  const allButtonsAreLinks = buttons.every(button => button.isLink)
  const isLayoutStacked = layout === 'stacked'
  const isLayoutSplit = layout === 'split'

  return (
    <div className={styles['button-group']}>
      {headline && <p>{headline}</p>}
      <div
        className={cx([
          styles['button-group-wrapper'],
          styles[`button-group-wrapper--layout-${layout}`],
          allButtonsAreLinks && styles['button-group-wrapper--is-link-group'],
          styles[`button-group-wrapper--justify-${justifyOverride}`]
        ])}
      >
        {buttons.map((button, index) => {
          const isLink = button?.isLink
          const linkLocation = analytics?.linkLocation
          const linkModule = analytics?.linkModule
          const parentHeadline = analytics?.parentHeadline

          // Merge group analytics and button analytics
          const mergedAnalytics = {
            ...analytics,
            ...button.analytics, // button specific data (like eventData)
            linkLocation,
            linkModule,
            // clickTracking produces: {linkModule}:{parentHeadline}:{button.title}:cta
            clickTracking: linkModule
              ? [linkModule, parentHeadline, button?.title, 'cta'].filter(Boolean).join(':')
              : undefined,
            linkPosition: getGtmLinkPosition(buttons, index)
          }

          return (
            <Fragment key={button.id || index}>
              <Button
                {...button}
                isFullWidth={isFullWidthOverride || isLayoutSplit || isLayoutStacked}
                size={buttonSizeOverride || button.size}
                justify={justifyOverride}
                analytics={mergedAnalytics}
              />
              {isLink && index < buttons.length - 1 && <span>,&nbsp;</span>}
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default ButtonGroup
